import React from 'react';

import 'Siteadmin/siteadmin.scss';

function HomePage() {

    return (
        <div className="mets-siteadmin">
            Welcome to METS Siteadmin React Component
        </div>
    );

}

export default HomePage;